import { render, staticRenderFns } from "./pagination.html?vue&type=template&id=73c5456b&scoped=true&"
import script from "./pagination.js?vue&type=script&lang=js&"
export * from "./pagination.js?vue&type=script&lang=js&"
import style0 from "./pagination.scss?vue&type=style&index=0&id=73c5456b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c5456b",
  null
  
)

export default component.exports